<template>
  <v-row>
    <v-col sm="6" >
      <v-form v-on:submit.prevent="submitForm()" v-model="valid" ref="form">
        <v-card flat :border="true">
          <v-card-text>
            <v-text-field
              :label="t('name', 1)"
              v-model="vehicle.name"
              required
              variant="underlined"
            ></v-text-field>

            <v-text-field
              :label="t('licensePlate')"
              v-model="vehicle.license_plate"
              required
              variant="underlined"
            ></v-text-field>

            <v-text-field
              :label="t('externalId')"
              v-model="vehicle.external_id"
              variant="underlined"
            ></v-text-field>

            <v-autocomplete
              :label="t('branch', 1)"
              v-model="vehicle.branch_id"
              :items="branchStore.getters.branches"
              item-title="name"
              item-value="id"
              variant="underlined"
              required
            ></v-autocomplete>

            <v-autocomplete
              :label="t('vehicleType', 1)"
              v-model="vehicle.vehicle_type_id"
              :items="vehicleTypeStore.getters.vehicleTypes"
              item-title="name"
              item-value="id"
              variant="underlined"
              required
            >
              <template v-slot:item="{ props, item }">
                <v-list-item
                  v-bind="props"
                  :title="`${item.raw.brand} ${item.raw.model} (${translateVehicleTypeName(item.raw.name)})`"
                >
                  <template v-slot:prepend>
                    <img v-if="item.raw.image_url" :src="item.raw.image_url" class="vehicle-type-thumb" />
                  </template>
                </v-list-item>
              </template>
              <template v-slot:selection="{ item }">
                <img v-if="item.raw.image_url" :src="item.raw.image_url" class="vehicle-type-thumb mr-2" />
                {{ item.raw.brand }} {{ item.raw.model }} ({{ translateVehicleTypeName(item.raw.name) }})
              </template>
            </v-autocomplete>

            <v-text-field
              :label="t('year')"
              v-model="vehicle.year"
              type="number"
              variant="underlined"
            ></v-text-field>

            <v-select
              :label="t('fuelType')"
              v-model="vehicle.fuel_type"
              :items="fuelTypeOptions"
              item-title="title"
              item-value="value"
              variant="underlined"
            ></v-select>

            <v-select
              :label="t('status')"
              v-model="vehicle.status"
              :items="statusOptions"
              item-title="title"
              item-value="value"
              variant="underlined"
            ></v-select>

          </v-card-text>
          <v-card-actions>
            <v-btn color="orange-darken-2" depressed type="submit" v-show="!loading" :disabled="!valid">
              {{ buttonText }}
            </v-btn>
            <v-progress-circular indeterminate color="orange-darken-2" v-show="loading"></v-progress-circular>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { branchStore } from '@/store/branches'
import { vehicleTypeStore } from '@/store/vehicleTypes'
import { useFuelTypes } from '@/utils/fuelTypes'
import { useVehicleTypeNames } from '@/utils/vehicleTypeNames'
import { useVehicleStatuses } from '@/utils/vehicleStatuses'

const props = defineProps({
  vehicle: {
    type: Object,
    required: true
  },
  submit: {
    type: Function,
    required: true
  },
  onInput: {
    type: Function,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  buttonText: {
    type: String,
    default: 'Save'
  }
})

const { t } = useI18n()
const { fuelTypeOptions } = useFuelTypes()
const { translateVehicleTypeName } = useVehicleTypeNames()
const { statusOptions } = useVehicleStatuses()

const valid = ref(false)
const form = ref()

if (!props.vehicle.status) {
  props.vehicle.status = 'ACTIVE'
}

onBeforeMount(() => {
  branchStore.dispatch('fetchBranches')
  vehicleTypeStore.dispatch('fetchVehicleTypes')
})

const submitForm = () => {
  props.submit()
}
</script>

<style scoped>
.vehicle-type-thumb {
  width: 60px;
  height: 20px;
  object-fit: contain;
  border-radius: 2px;
  vertical-align: middle;
}
</style>
